import React, { createContext, useState, useContext, useEffect } from 'react'
import { languageCode } from '../../Contansts'

const LanguageContext = createContext()

export const useLanguage = () => useContext(LanguageContext)

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState()

  useEffect(() => {
    document.body.style.direction =
      language?.code === languageCode?.ARABIC ? 'rtl' : 'ltr'
  }, [language])

  const setLanguage = (lang) => {
    setLanguageState(lang)
    localStorage.setItem('lang', JSON.stringify(lang))
  }

  useEffect(() => {
    function fetchLanguage() {
      let storedLang = localStorage.getItem('lang')
      if (storedLang) {
        let parsedLang = JSON.parse(storedLang)
        setLanguage(parsedLang)
      } else {
        setLanguage({
          label: 'English',
          code: 'en',
        })
      }
    }
    fetchLanguage()
  }, [])

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  )
}
